var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgXIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 20,
    xmlns: "http://www.w3.org/2000/svg",
    clipRule: "evenodd",
    fillRule: "evenodd",
    imageRendering: "optimizeQuality",
    textRendering: "geometricPrecision",
    shapeRendering: "geometricPrecision",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("title", null, "Layer 1"), /*#__PURE__*/React.createElement("path", {
    stroke: "null",
    id: "svg_1",
    d: "m17.80335,2.03701l3.04097,0l-6.64376,6.89445l7.8161,9.38154l-6.12014,0l-4.79317,-5.69l-5.48464,5.69l-3.04306,0l7.10623,-7.37425l-7.49781,-8.90173l6.27512,0l4.3328,5.20073l5.01137,-5.20073zm-1.0674,14.62327l1.68519,0l-10.87752,-13.05732l-1.80817,0l11.00051,13.05732z",
    fillRule: "nonzero",
    fill: "#fff"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgXIcon);
export default __webpack_public_path__ + "static/media/x-icon.40811c331ab382415dafcbb7e3a1d5a0.svg";
export { ForwardRef as ReactComponent };